import * as Yup from 'yup';

const schema = Yup.object().shape({
  reason: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string().required('Please select a reason'),
  }),
  notes: Yup.string().required('Please provide your feedback'),
});

export default schema;
